import { Link } from 'react-router-dom';

const articleImages: Record<string, string> = {
  'wynn-palace-suite-booking-guide': 'https://readdy.ai/api/search-image?query=Luxury%20Macau%20hotel%20suite%20bedroom%20with%20cream%20silk%20bedding%2C%20elegant%20warm%20golden%20lighting%2C%20floor%20to%20ceiling%20windows%2C%20asian%20luxury%20interior%20design%2C%20stylized%20editorial%20photography%2C%20soft%20ambient%20light%2C%20clean%20composition&width=800&height=500&seq=article-hotel-01&orientation=landscape',
  'wynn-palace-michelin-restaurants': 'https://readdy.ai/api/search-image?query=Michelin%20star%20restaurant%20exquisite%20dish%20presentation%20with%20golden%20chandelier%20background%2C%20fine%20dining%20atmosphere%2C%20warm%20elegant%20lighting%2C%20asian%20luxury%20aesthetic%2C%20stylized%20food%20photography%2C%20soft%20cream%20tones%2C%20clean%20composition&width=800&height=500&seq=article-dining-01&orientation=landscape',
  'wynn-palace-performance-lake-show': 'https://readdy.ai/api/search-image?query=Magnificent%20night%20water%20fountain%20show%20with%20colorful%20illuminated%20jets%20and%20fire%20effects%2C%20grand%20luxury%20building%20backdrop%2C%20dramatic%20lighting%2C%20stylized%20artistic%20photography%2C%20reflection%20on%20water%2C%20cinematic%20wide%20shot&width=800&height=500&seq=article-entertainment-01&orientation=landscape',
  'wynn-palace-luxury-shopping': 'https://readdy.ai/api/search-image?query=Luxury%20boutique%20storefront%20with%20golden%20warm%20lighting%2C%20marble%20floor%20reflections%2C%20high%20end%20fashion%20display%2C%20elegant%20mall%20interior%2C%20asian%20luxury%20aesthetic%2C%20stylized%20editorial%20photography%2C%20soft%20cream%20tones&width=800&height=500&seq=article-shopping-01&orientation=landscape',
};

const featuredArticles = [
  {
    slug: 'wynn-palace-suite-booking-guide',
    title: '永利皇宫套房预订全攻略：从房型选择到入住体验',
    excerpt: '详解永利皇宫各类套房房型差异、预订技巧与最佳入住时节，助您以最优价格享受尊贵住宿体验。',
    categoryName: '酒店预订',
    readTime: '8分钟',
    author: '永利皇宫体验官',
    publishDate: '2026-08-10',
  },
  {
    slug: 'wynn-palace-michelin-restaurants',
    title: '永利皇宫米其林星级餐厅全收录：舌尖上的奢华之旅',
    excerpt: '盘点永利皇宫内所有米其林星级及推荐餐厅，从粤式经典到环球美馔，带您领略顶级餐饮体验。',
    categoryName: '餐厅推荐',
    readTime: '10分钟',
    author: '永利皇宫美食顾问',
    publishDate: '2026-08-08',
  },
  {
    slug: 'wynn-palace-performance-lake-show',
    title: '永利皇宫表演湖音乐喷泉：日夜不同的视觉盛宴',
    excerpt: '永利皇宫标志性的表演湖是全球最大的音乐喷泉之一，本文为您详解最佳观赏位置与演出时间表。',
    categoryName: '娱乐体验',
    readTime: '6分钟',
    author: '永利皇宫娱乐向导',
    publishDate: '2026-08-05',
  },
  {
    slug: 'wynn-palace-luxury-shopping',
    title: '永利皇宫名店街购物指南：顶级品牌一站购齐',
    excerpt: '永利皇宫名店街汇聚超过50个国际奢侈品牌，为您详解各品牌位置、特色单品与购物贴士。',
    categoryName: '购物指南',
    readTime: '7分钟',
    author: '永利皇宫时尚编辑',
    publishDate: '2026-08-03',
  },
];

export default function FeaturedArticles() {
  return (
    <section className="w-full px-4 md:px-6 py-16 md:py-20 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between gap-4 mb-12">
          <div>
            <span className="inline-block px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-3">
              精选文章
            </span>
            <h2 className="font-heading text-2xl md:text-3xl font-semibold text-foreground-900">
              最新体验分享
            </h2>
            <p className="text-foreground-600 text-sm mt-2">
              由资深体验官为您带来最真实的永利皇宫深度攻略
            </p>
          </div>
          <Link
            to="/category/travel"
            className="flex items-center gap-1.5 text-primary-600 hover:text-primary-700 text-sm font-medium whitespace-nowrap transition-colors"
          >
            查看全部文章 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {featuredArticles.map((article) => (
            <Link
              key={article.slug}
              to={`/article/${article.slug}`}
              className="group rounded-xl bg-background-100 border border-secondary-200/60 overflow-hidden hover:border-primary-300/50 transition-all duration-300 cursor-pointer"
            >
              <div className="aspect-[16/10] overflow-hidden">
                <img
                  src={articleImages[article.slug]}
                  alt={article.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="p-5">
                <div className="flex items-center gap-2 mb-3">
                  <span className="px-2 py-0.5 rounded-md bg-primary-100 text-primary-700 text-xs font-medium">
                    {article.categoryName}
                  </span>
                  <span className="text-foreground-400 text-xs">{article.readTime}</span>
                </div>
                <h3 className="font-heading text-sm font-semibold text-foreground-900 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
                  {article.title}
                </h3>
                <p className="text-foreground-600 text-xs leading-relaxed line-clamp-2 mb-3">
                  {article.excerpt}
                </p>
                <div className="flex items-center justify-between text-xs text-foreground-400">
                  <span>{article.author}</span>
                  <span>{article.publishDate}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}